module.exports = __webpack_public_path__ + "img/4-9.132f5eee.png";